/* eslint-disable react/prop-types */

import type { ProductboardCreateNoteBody } from '@lmc/ts-common'
import { ComingSoonCard, PresentationCard, theme } from '@lmc/ui-kit'
import { postJSON } from 'common/services/api'
import { NAMESPACE } from 'locale'
import { goalsConstants } from 'locale/goals'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import styled from 'styled-components'
import CONSTANTS from 'utils/constants'

const GoalsComingSoon = () => {
  const { t } = useTranslation(NAMESPACE.GOALS)
  const isProduction = CONSTANTS.PROD
  const productboardNoteUrl = 'services/productboard/notes'
  let title: string
  let content: string

  const tags: string[] = ['teaser']

  if (isProduction) {
    title = 'User interested in Goals&Outcomes'
    content = 'A new user expressed interest in the new feature.'
    tags.push('prod')
  } else {
    title = 'Test User interested in Goals&Outcomes'
    content = 'A user is testing the application'
    tags.push('dev')
  }

  const mutationFunction = (): Promise<{
    result: ProductboardCreateNoteBody
  }> =>
    postJSON({
      method: 'POST',
      url: productboardNoteUrl,
      json: { title, content, tags }
    })

  const { mutateAsync } = useMutation(mutationFunction)

  return (
    <ContentWrapper>
      <ComingSoonCard
        title={t(goalsConstants.COMING_SOON_CARD_TITLE)}
        subtitle={t(goalsConstants.COMING_SOON_CARD_SUBTITLE)}
        description={t(goalsConstants.COMING_SOON_CARD_DESCRIPTION)}
        listItems={[
          t(goalsConstants.FEATURE_LIST_ROW_1),
          t(goalsConstants.FEATURE_LIST_ROW_2),
          t(goalsConstants.FEATURE_LIST_ROW_3),
          t(goalsConstants.FEATURE_LIST_ROW_4),
          t(goalsConstants.FEATURE_LIST_ROW_5),
          t(goalsConstants.FEATURE_LIST_ROW_6)
        ]}
        backgroundColor={theme.color.background.secondary}
        backgroundImage="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/paywall/logo-transparent.png"
        footerText={t(goalsConstants.COMING_SOON_CARD_FOOTER_TEXT)}
      />
      <PresentationCard
        contentRows={[
          t(goalsConstants.ADD_CONTENTS_ROW_1),
          t(goalsConstants.ADD_CONTENTS_ROW_2),
          t(goalsConstants.ADD_CONTENTS_ROW_3),
          t(goalsConstants.ADD_CONTENTS_ROW_4)
        ]}
        leftImage="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/paywall/goals-add-goal.png"
        descriptionRows={[
          t(goalsConstants.DESCRIPTION_ROW_1),
          t(goalsConstants.DESCRIPTION_ROW_2)
        ]}
        onCtaClick={mutateAsync}
      />
      <PresentationCard
        contentRows={[
          t(goalsConstants.CREATE_CONTENTS_ROW_1),
          t(goalsConstants.CREATE_CONTENTS_ROW_2),
          t(goalsConstants.CREATE_CONTENTS_ROW_3),
          t(goalsConstants.CREATE_CONTENTS_ROW_4)
        ]}
        rightImage="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/paywall/goals-action-plan.png"
        descriptionRows={[
          t(goalsConstants.DESCRIPTION_ROW_1),
          t(goalsConstants.DESCRIPTION_ROW_2)
        ]}
        onCtaClick={mutateAsync}
      />
    </ContentWrapper>
  )
}

const ContentWrapper = styled.div`
  padding-top: 24px;
`

export default GoalsComingSoon
